import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../api';

export const APP_NAME = 'SparkSync';
export const SUPPORT_EMAIL = 'support@sparksync.app';
// TODO: replace with the real store listing URLs once published.
export const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sparksync.stackerio';
export const APP_STORE_URL = '#';

// Admin-controlled announcement banner (placement: "website").
export function TopBanner() {
  const [banner, setBanner] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/content/banners?placement=website`)
      .then((r) => r.json())
      .then((d) => { if (d.success && d.data.banners.length) setBanner(d.data.banners[0]); })
      .catch(() => {});
  }, []);
  if (!banner) return null;
  const inner = <>✨ {banner.title}{banner.link ? ' →' : ''}</>;
  return banner.link
    ? <a className="top-banner" href={banner.link} target="_blank" rel="noreferrer">{inner}</a>
    : <div className="top-banner">{inner}</div>;
}

export function Nav() {
  return (
    <div className="wrap">
      <nav className="nav">
        <Link className="brand" to="/">
          <img src="/logo.png" alt="SparkSync" />
          <b className="grad-text">SparkSync</b>
        </Link>
        <div className="nav-links">
          <a href="/#features">Features</a>
          <a href="/#how">How it works</a>
          <a href="/#plans">Plans</a>
          <a href="/#faq">FAQ</a>
          <a className="btn-grad" href={PLAY_URL} target="_blank" rel="noreferrer">Get the App</a>
        </div>
      </nav>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-cols">
          <div className="col" style={{ maxWidth: 300 }}>
            <Link className="brand" to="/" style={{ marginBottom: 12 }}>
              <img src="/logo.png" alt="" style={{ width: 36, height: 36 }} />
              <b className="grad-text">SparkSync</b>
            </Link>
            <p style={{ color: 'var(--dim)', fontSize: 14, lineHeight: 1.6 }}>
              Connect. Match. Spark. Meet real people and start something real.
            </p>
          </div>
          <div className="col">
            <h4>Product</h4>
            <a href="/#features">Features</a>
            <a href="/#plans">Membership</a>
            <a href={PLAY_URL} target="_blank" rel="noreferrer">Download</a>
          </div>
          <div className="col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/delete-account">Delete Account</Link>
            <Link to="/child-safety">Child Safety</Link>
          </div>
          <div className="col">
            <h4>Support</h4>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            <Link to="/admin">Admin</Link>
          </div>
        </div>
        <div className="copyright">© {new Date().getFullYear()} SparkSync. All rights reserved.</div>
      </div>
    </footer>
  );
}
